import { Component, OnInit, input } from '@angular/core';
import { KioskService } from '@core/services/kiosk/kiosk.service';

@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
})
export class MainLayoutComponent implements OnInit {
  readonly footer = input<unknown[]>([]);
  readonly globalFeatures = input<unknown[]>([]);
  readonly displayDefaultDoodFooter = input(true);
  readonly displayOrderStatusUpdateNotification = input(true);
  readonly isKioskLayout = input(false);

  constructor(private readonly kioskService: KioskService) {}

  ngOnInit() {
    this.kioskService.saveKioskLayoutToStore(this.isKioskLayout());
  }
}
